import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { Template } from 'src/app/data/models/template.model';
import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getStepDetails, getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
//import { FroalaEditorOptions } from '../../../../data/constants/froala-editor-options';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { GCI140Service } from '../../../../services/gci140.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { getSuperTask } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { NgForm } from '@angular/forms';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { map } from 'rxjs/internal/operators/map';
//import * as  froalaService from 'src/app/modules/utility/froala-service';
import { SuperTask } from 'app-models';
import { UploadImageDialogComponent } from "../../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'i140-letter-template',
  templateUrl: './letter-template.component.html',
  styleUrls: ['./letter-template.component.scss']
})
export class LetterTemplateComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('letterTemplateForm', { static: true }) letterTemplateForm: NgForm;

  @ViewChild("templateimageupload") public templateimageupload: UploadImageDialogComponent;
  @Output() @ViewChild("templatekendoeditor") public templatekendoeditor: EditorComponent;

  templateList: Template[];
  listTemplateColumns: any;
  disabledControls: boolean;
  expandedElement: any | null;
  letterTextContent: string;
  isAdditionalInfoCoverLetter: boolean;
  // public options: any = FroalaEditorOptions.EditorOptions;
  additionalInfo: string;
  additionalInforRdBtn: string;
  isOwnTemplateUsed: boolean;
  lastUsedTemplateId: number;
  letterType: string;
  recordsPerPage: number;

  @Input()
  data: any;
  @Output()
  selectedTemplateObject = new EventEmitter();
  @Input()
  disabledCtrls: boolean = false;

  @Input()
  selectedTemplateId: number;

  @Output()
  redirectionComponent: EventEmitter<string> = new EventEmitter<string>();

  @Input() 
  isWizard: boolean = false;

  observableSubscription$ = new Subject();
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  superTaskDetails: SuperTask;
  subTaskDetails: SubTaskDetails;

  constructor(
    protected store: Store<any>,
    private toastr: ToastrService,
    private gcI140Service: GCI140Service,
    private dynamicDialogConfig: DynamicDialogConfig,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.recordsPerPage = 25;
    this.letterTextContent = '';
    this.letterType = sessionStorage.getItem('typeOfLetter');
    this.listTemplateColumns = [
      { field: 'templateName', header: 'Template Name', },
      { field: 'documentType', header: 'Document Type' },
      { field: 'immCategoryType', header: 'Category Type' },
      { field: 'immClassificationType', header: 'Classification Type' },
      { field: 'templateType', header: 'Template Type' },
      { field: 'isDefault', header: '' }
    ];
    // this.options.height = 200;
    this.isAdditionalInfoCoverLetter = null;
    this.additionalInfo = 'No';
    if (sessionStorage.getItem('typeOfLetter') === 'COVLTR') {
      this.isOwnTemplateUsed = sessionStorage.getItem('templateUsed') === 'OWN' ? false : true; // Dont display is user has own template
    }
    else {
      this.isOwnTemplateUsed = true;
    }
  }

  ngOnInit(): void {
    this.store.select(getSuperTask).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SuperTask) => {
      this.superTaskDetails = data;
    })
    // Get Specific Task Details
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      this.subTaskDetails = data;
    });
    
    if(this.dynamicDialogConfig.data.stepId) {
      
      // Get Specific step details by passing step code
      this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
        this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
        this.stepDetails = data;
        this.getTemplateList(this.stepDetails.companyId);
        this.toggleControlsStatus();
      });
    } else {
      this.getTemplateList(this.dynamicDialogConfig.data.companyId)
    }
    

  }

  public templateimageuploaddialog() {
    this.templateimageupload.open();
  }

  ngAfterViewInit() {
    this.letterTemplateForm.form.valueChanges.pipe(
      map(() => this.letterTemplateForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  handleToggle({ value }) {
    this.additionalInfo = value;
    if (value === 'YES') {
      this.getAdditionalInfo();
    }
  }

  handleSavePreview(type: string) {
    if (type === 'Save') {
      let payload = {
        "additionalText": type === 'Save' ? this.letterTextContent : '',
        "infoType": sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST',
      };
      this.gcI140Service.postAddtionalInfo(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, payload).subscribe((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.redirectionComponent.emit('LetterPreview');
          sessionStorage.setItem('templateUsed', 'TMPLT');
        }
      });
    }
    else {
      this.gcI140Service.deleteTemplateInfo(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST').subscribe((response: ImagilityBaseResponse) => {
        // if (response && response.status === 200) {
        //   this.toastr.success(response.message);
        // }
        this.redirectionComponent.emit('LetterPreview');
        sessionStorage.setItem('templateUsed', 'TMPLT');
      });
    }
  }

  getAdditionalInfo() {
    this.gcI140Service.getAdditionalInfo(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
      if (response.data && response.data) {
        this.letterTextContent = response.data.find(x => x.infoTypeCode === (this.letterType === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST')) ? response.data.find(x => x.infoTypeCode === (this.letterType === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST'))['additionalText'] : '';
        this.additionalInfo = this.letterTextContent.length > 0 ? 'Yes' : 'No';
        //froalaService.insertPageBreak();
      }
    });
  }

  createNew() {
    this.redirectionComponent.emit("CreateTemplate");
  }

  getTemplateList(companyId, pageIndex: number = 0, recordsPerPage: number = this.recordsPerPage) {
    const payload = {
      "immClassificationType": this.superTaskDetails.immigrationClassification.code,
      "immCategoryType": this.superTaskDetails.immigrationCategory.code,
      "superTaskTypeId": "IMMPET",
      "isDefault": null,
      "pageNumber": 0,
      "pageSize": 0,
      "pageIndex": pageIndex,
      "recordsPerPage": recordsPerPage,
      "searchText": "",
      "documentType": sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? 'COVLTR' : 'SUPLTR',
      taskTypeId: this.subTaskDetails.taskTypeId,
      taskId: this.subTaskDetails?.id || this?.data?.subTaskId || null
    }
    this.gcI140Service.getI140LetterTemplateList(companyId, payload).subscribe((response) => {
      this.gcI140Service.getLastUsedTemplate(companyId, this.data.i140CaseId).subscribe((response: ImagilityBaseResponse) => {
        this.lastUsedTemplateId = sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? response.data['coverLetterTemplateId'] : response.data['supportLetterTemplateId'];
        this.selectedTemplateObject.emit(sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? response.data['coverLetterTemplateId'] : response.data['supportLetterTemplateId']);
      });
      if (response['data']['documentTemplate'] && response['data']['documentTemplate'].length > 0) {
        this.templateList = (response['data']['documentTemplate'] as []).filter(x => (x['companyId'] == companyId || x['companyId'] == '') && (x['documentType'] === sessionStorage.getItem('typeOfLetter')));
      }
      else {
        this.templateList = [];
      }
    });
  }

  onRowExpand(event) {
    sessionStorage.setItem('documentTemplateId', event.data.id);
    this.getAdditionalInfo();
  }

  handleBack() {
    this.redirectionComponent.emit('CreateTemplate');
  }

  handlePageSettingsChange(event) {   
    this.getTemplateList(this.stepDetails.companyId, event.page, this.recordsPerPage);
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
  public letterTextContenteditorValueChange(value: string): void {
    this.letterTextContent = value;
  }
}
